// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"79":"components-modal-inform","171":"components-modal-connections","368":"component"}[chunkId] || chunkId) + "." + {"79":"1a674dbf","171":"06319bcc","368":"abe8ebb1","505":"99533d18","514":"a071ec61","592":"b0718336","672":"5e1901b8"}[chunkId] + ".chunk.css";
};